angular.module('app').controller('PspaFileCopyCtrl', function($controller, $scope, $http, $rootScope, mode) {
    "ngInject";

    var main = this;
    var target = null;
    main.name = 'event';
    main.mode = mode;
    main.src = '/home/lftl/Pictures';
    main.dest = '/home/lftl/';
    // main.src = '/Users/scottwehrenberg/Desktop/Evans Photos/untitled folder 2';
    // main.dest = '/Users/scottwehrenberg/';
    main.results = [];
    main.fileMap = {};
    main.renameFiles = 'None';
    main.renameQuestion = false;
    main.resizeFiles = false;
    main.resizeLength = null; 

    main.sanitize = function(str) {
        return str.replace(/[\/\\:\*\?"<>\|]/gi, '_').toLowerCase();
    }

    main.loadSubjects = function() {
        main.loading = $http.get('/api/v1/admin/event_signup?page=1&results_per_page=10000&q={"filters":[{"name":"event_id","op":"eq","val":"'+ main.id +'"}],"order_by":[{"field":"last_name","direction":"asc"}]}').then(
            function(response) {
                main.subjects = response.data.objects;
                main.subjects.forEach(main.findSelection);
                var seen_names = [];
                var files = main.subjects
                    .filter(function(item) {
                        if(item.selection) {
                            return true;
                        }
                    })
                    .map(function(item) {
                        var class_name = item.answers[$rootScope.CLASS_NAME_QUESTION_ID];
                        if(typeof class_name == 'undefined' || class_name == '') {
                            class_name = '';
                        } else {
                            class_name = class_name + '-';
                        }
                        if(main.renameFiles == 'Question') {
                            if(!main.renameQuestion) {
                                alert('You must select a question to rename the files');
                                return;
                            }

                            var newName = item.answers[main.renameQuestion.question.id]
                            if(typeof newName == 'undefined') {
                                return [item.selection.filename, main.sanitize(`${class_name}${item.last_name}-${item.first_name}`)];
                            } 

                            return [item.selection.filename, main.sanitize(`${newName}`)];
                        } else if (main.renameFiles == 'Class Last First') {
                            return [item.selection.filename, main.sanitize(`${class_name}${item.last_name}-${item.first_name}`)];
                        } else if (main.renameFiles == 'ID Number') {
                            return [item.selection.filename, main.sanitize(`${item.id_number}`)];
                        } else {
                            return [item.selection.filename, item.selection.filename.replace(/.jpg$/i, '')];
                        }
                    }).map(function(item) {
                        let counter = 2;
                        let originalName = item[1];
                        while (seen_names.includes(item[1])) {
                            item[1] = `${originalName}-${counter}`;
                            counter++;
                        }
                        seen_names.push(item[1]);
                        item[1] += '.jpg';
                        return item;
                    });
                main.fileMap = {};
                main.subjects.forEach(function(item) {
                    if(item.selection) {
                        main.fileMap[item.selection.filename] = item;
                    }
                });
                main.results = [];
                console.log(files);
                $rootScope.ezgo.copyFiles(
                    main.src,
                    main.dest,
                    files,
                    { 'resizeFiles': main.resizeFiles ? main.resizeLength : false }
                );
            }
        );
    }

    main.findSelection = function(item) {
        item.photos.forEach(function(photo) {
            if(photo.yearbook_selection) {
                item.selection = photo;
                item.explicit_yearbook_selection = true;
                return false;
            }

            if(photo.yearbook_candidate && !item.selection) {
                item.selection = photo;
                item.explicit_yearbook_selection = false;
                return false;
            }
        });
    }

    $scope.$on('ezgo-app:directoryChosen', function(event, data) {
        console.log(event, data)
        if(target) {
            main[target] = data.results;
            target = null;
            $scope.$apply();
        }
    });

    $scope.$on('ezgo-app:filesCopied', function(event, data) {
        console.log(event, data)
        main.loading = false;
        main.results = data.results;
        console.log(main.fileMap);
        main.results.forEach(function(result) {
            result.subject = main.fileMap[result.filename[0]];
        });
        main.resultCounts = main.results.reduce((acc, obj) => {
            acc[obj.code] = (acc[obj.code] || 0) + 1;
            return acc;
        }, {}); 
        $scope.$apply();
    });

    main.load = function() {
        if(main.mode == 'generic') {
            return;
        }

        main._load();
    }
    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.chooseDirectory = function(t) {
        target = t;
        $rootScope.ezgo.chooseDirectory();
    };

    main.save = function() {
        if(main.dest == main.src) {
            $rootScope.util.toast("Source and destination cannot be the same");
            return false;
        }

        if(main.mode == 'generic') {
            $rootScope.ezgo.copyFiles(
                main.src,
                main.dest,
                [],
                {
                    'resizeFiles': main.resizeFiles ? main.resizeLength : false,
                    'copyAllFromSrc': true
                }
            );
            return;
        }
        main.loadSubjects();
    }


});